<template>
  <section class="spider" :class="`spider--${theme} spider--${layout}`">
    <div class="spider__title">
      {{ $t(`titles.${title}`) }}
    </div>
    <div class="spider__bars">
      <span
        v-for="(specPair, index) in specs"
        :key="index"
        class="spider__bar"
        :class="{
          'spider__bar--highlighted': specPair[1] > HIGHLIGHTED_THRESHOLD,
          'spider__bar--active': isActive && specPair[1] > HIGHLIGHTED_THRESHOLD,
        }"
        :style="getBarStyle(specPair[1])"
      >
        <FormattedText :text="$t(`${type}.${specPair[0].replace(/\-/g, '')}`)" />
      </span>
    </div>
  </section>
</template>

<script>
import { observeIntersection } from '@/helpers/intersection-observer'
import FormattedText from '@/components/_shared/FormattedText.vue'

const HIGHLIGHTED_THRESHOLD = 3

export const LAYOUTS = {
  vertical: 'vertical',
  horizontal: 'horizontal',
}

export default {
  name: 'Spider',
  components: {
    FormattedText,
  },
  props: {
    layout: {
      type: String,
      default: LAYOUTS.vertical,
      validator: layout => Object.values(LAYOUTS).includes(layout),
    },

    specs: {
      type: Array,
      required: true,
    },

    theme: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      default: 'shoes',
    },
  },

  data() {
    return {
      isActive: false,
      HIGHLIGHTED_THRESHOLD,
    }
  },

  mounted() {
    observeIntersection(this.$el, () => this.setBarToActive(), {
      rootMargin: '0px',
      threshold: 1,
    })
  },

  methods: {
    setBarToActive() {
      this.isActive = true
    },

    getBarStyle(points) {
      const opacity = points > HIGHLIGHTED_THRESHOLD ? points / 10 : 1
      return `opacity: ${opacity}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Spider';
</style>

<i18n src="@/locales/spider.json">
</i18n>
